import Model from 'flarum/common/Model';

/**
 * Modelo cliente de `umbral-meetup-requests`. Gemelo de `GroupRequest` — ver su cabecera para
 * el porqué de registrarlo aunque nadie lo instancie a mano (la notificacion de la campanita
 * trae la solicitud como `subject` incluido) y para el porqué el atributo se llama `answers`
 * y no `payload` (nombre reservado por `Store.pushPayload()` del cliente).
 */
export default class MeetupRequest extends Model {
  status = Model.attribute<string>('status');

  /** `form` | `migrated` — ver `MeetupRequest::SOURCE_FORM`/`SOURCE_MIGRATED` en el servidor. */
  source = Model.attribute<string>('source');

  answers = Model.attribute<Record<string, any> | undefined>('answers');

  createdAt = Model.attribute<Date | undefined>('createdAt', Model.transformDate);
  handledAt = Model.attribute<Date | undefined>('handledAt', Model.transformDate);

  user = Model.hasOne<any>('user');
  decidedBy = Model.hasOne<any>('decidedBy');

  /**
   * La ruta REAL — mismo motivo que `GroupRequest::apiEndpoint()`: sin este override,
   * `request.save(...)` desde la cola del panel se iria a un 404.
   */
  protected apiEndpoint(): string {
    return '/umbral/meetup-requests' + ('id' in this.data ? '/' + this.data.id : '');
  }
}
